import React, { createContext, useContext, useEffect, useState } from 'react';

const ShiprocketContext = createContext();

export const ShiprocketProvider = ({ children }) => {
  const [shiprocket, setShiprocket] = useState(() => {
    const saved = localStorage.getItem('shiprocket');
    return saved ? JSON.parse(saved) : null;
  });

  useEffect(() => {
    if (shiprocket) {
      localStorage.setItem('shiprocket', JSON.stringify(shiprocket));
    } else {
      localStorage.removeItem('shiprocket');
    }
  }, [shiprocket]);

  const clearShiprocket = () => {
    setShiprocket(null);
    localStorage.removeItem('shiprocket');
  };

  return (
    <ShiprocketContext.Provider
      value={{
        shiprocket,
        setShiprocket,
        clearShiprocket,
        token: shiprocket?.token || ''
      }}>
      {children}
    </ShiprocketContext.Provider>
  );
};

export const useShiprocket = () => useContext(ShiprocketContext);

export default ShiprocketContext;
